import { useDispatch } from 'react-redux'
import { Button, Text } from '../../../Components'
import { defineMessages, useIntl } from 'react-intl'
import { setBombBombOpen } from '../../../store/slices/bombBomb'

import styles from '../BombBombSaveForm/BombBombSaveForm.module.scss'

export const MSG = defineMessages({
  headline: {
    id: 'BombBomb.panel.close.headline',
    defaultMessage: 'Are you sure you want to exit BombBomb?'
  },
  message: {
    id: 'BombBomb.panel.close.message',
    defaultMessage:
      'Your current state will not be saved. If you want to hide/show the pane while recording, click the button containing the eye icon above the close button.'
  },
  cancelBtn: {
    id: 'general.cancel',
    defaultMessage: 'Cancel'
  },
  exitBtn: {
    id: 'BombBomb.panel.close.exitBtn',
    defaultMessage: 'Exit BombBomb'
  }
})

export interface BombBombCloseAlertProps {
  setIsAlertOpen(isOpen: boolean): void
}

export const BombBombCloseAlert = ({ setIsAlertOpen }: BombBombCloseAlertProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const handleSubmit = e => {
    e.preventDefault()
    setIsAlertOpen(false)
    dispatch(setBombBombOpen(false))
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <Text element='p' variant='neutralCool' variantCount='900' weight='bold'>
        {intl.formatMessage(MSG.headline)}
      </Text>
      <Text element='p' variant='neutralCool' variantCount='700' size='s'>
        {intl.formatMessage(MSG.message)}
      </Text>
      <Button wide onClick={() => setIsAlertOpen(false)}>
        {intl.formatMessage(MSG.cancelBtn)}
      </Button>
      <Button primary danger wide type='submit'>
        {intl.formatMessage(MSG.exitBtn)}
      </Button>
    </form>
  )
}
